import QueryParameterService from "./QueryParameterService";

export interface AuthorizationResponse {
  code: string
  redirectUri?: string
}

export class RedirectionService {
  static redirect(response: AuthorizationResponse): void {
    const state = QueryParameterService.get('state')
    const redirectUri = response.redirectUri === undefined ? QueryParameterService.get('redirect_uri') : response.redirectUri
    window.location.href = `${redirectUri}?code=${response.code}&state=${state}`
  }
}
